export type Theme = "dark" | "light";

const KEY = "theme";

export function currentTheme(): Theme {
  return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

function show(theme: Theme): void {
  if (theme === "light") document.documentElement.dataset.theme = "light";
  else delete document.documentElement.dataset.theme;
}

export function applyTheme(theme: Theme): void {
  show(theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // Private windows can refuse storage; the theme still applies to this page.
  }
}

export function watchTheme(changed: (theme: Theme) => void = () => {}): () => void {
  const update = (event: StorageEvent) => {
    if (event.key !== KEY) return;
    const theme = event.newValue === "light" ? "light" : "dark";
    show(theme);
    changed(theme);
  };
  addEventListener("storage", update);
  return () => removeEventListener("storage", update);
}
